import React, { useState, useRef } from 'react'
import Timer from '../../timer/timer';
import Video from '../../video/video';
import Audio from '../../audio/audio';
import "./foodBuildGame.css"
import DragThingsToBoxesDemo from '../dnd/DragThingsToBoxes/DragThingsToBoxesDemo';
import { memo } from 'react';
import Modal from 'react-modal';

import styled, { keyframes } from 'styled-components';
import { fadeIn } from 'react-animations';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: 'none',
        border: 'none',
    },
};

const AnimationSlide = keyframes`${fadeIn}`;

const SlideDownInDiv = styled.div`
  animation: 2s ${AnimationSlide};
`;

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const FoodBuildingGame = (props) => {
    const actorName = "ERIK";
    const actorTitle = "Ghost Chef";
    const playVideo = useRef(null);
    const playAudio = useRef(null);
    const timerRef = useRef(null);


    //const posterURL = './actors/Erik.png';

    const posterURL = './actors/Black_BG.jpg';

    const congratulateVideoURL = './videos/4_2_Eriks_Clue_RevisedSep15.mp4';

    const waitingVideoURL = './videos/waitings/Erik_Waiting_1.mp4';

    const promptVideos = ['./videos/CNE-07-Chef-Prompt-01.mp4', './videos/CNE-07-Chef-Prompt-02.mp4', './videos/CNE-07-Chef-Prompt-03.mp4'];

    const [promptIndex, setPromptIndex] = useState(null);

    const [currentVideoURL, setCurrentVideoURL] = useState(null)

    let btnRef = useRef();
    let resetBtnRef = useRef();

    const [light1, setLight1] = useState('redLight');
    const [light2, setLight2] = useState('redLight');
    const [light3, setLight3] = useState('redLight');
    const [light4, setLight4] = useState('redLight');
    const [light5, setLight5] = useState('redLight');

    //modal
    const [isBlur, setIsBlur] = useState("blur");

    function showClear(event) {
        event.stopPropagation();
        setIsBlur("");
    }

    const [modalIsOpen, setIsOpen] = useState(false);

    const [gameOverModalIsOpen, setGameOverModalIsOpen] = useState(false);

    function openModal() {
        setIsBlur('blur');
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }
    function openGameOverModal() {
        setGameOverModalIsOpen(true);
    }

    function closeGameOverModal() {
        timerRef.current(props.initialTimeOut);
        setGameOverModalIsOpen(false);
    }
    function restartGame() {
        setGameOverModalIsOpen(false);
        props.goToStep(null, 'LandingPage');

    }

    //modal end

    const resetLights = () => {
        setLight1('redLight');
        setLight2('redLight');
        setLight3('redLight');
        setLight4('redLight');
        setLight5('redLight');
    }

    const handleSubmit = (event) => {

        event.preventDefault();

        fryItems();

    }
    const gotoFailed = (event, args) => {

        if (gameOverModalIsOpen) {

        } else {
            openGameOverModal();
        }
    }


    const [basket, setBasket] = useState([]);
    const [seed, setSeed] = useState(1);

    const updateBox = (event, args) => {

        setBasket(basket => [...basket, args]);

    }
    const resetGame = () => {
        resetLights();
        setSeed(Math.random());
        setBasket([]);
    }

    const updateVideoStatue = (value, src) => {
        if (value === "ended") {
            if (currentVideoURL === congratulateVideoURL) {
                props.goToStep(null, 'CarnivalPuzzle');
            } else if (waitingVideoURL === currentVideoURL) {
                playWaitingVideo();
            } else if (promptVideos.includes(currentVideoURL)) {
                playWaitingVideo();
            } else {
                playWaitingVideo();
            }
        }

    }

    const correctAnswer = [
        "./assets/foodfryer/Pickles_icons.png",
        "./assets/foodfryer/CookieDough_Icon.png",
        "./assets/foodfryer/IceCream_Icon.png",
        "./assets/foodfryer/ThanksgivingDinner_Icon.png",
        "./assets/foodfryer/Cheesecake_Icon.png",

        // "./assets/foodfryer/BubbleGum_Icon.png",
        // "./assets/foodfryer/Butter_Icon.png",
        // "./assets/foodfryer/Cheesecake_Icon.png",
        // "./assets/foodfryer/ChocolateBar_Icon.png",
        // "./assets/foodfryer/CookieDough_Icon.png",
        // "./assets/foodfryer/IceCream_Icon.png",
        // "./assets/foodfryer/Pickles_icons.png",
        // "./assets/foodfryer/ThanksgivingDinner_Icon.png"
    ];

    const isCorrectAnswer = () => {
        let result = true;
        if (basket.length === 5) {
            for (var i = 0; i < basket.length; i++) {
                let index = basket[i].id;
                if (basket[i].imageurl !== correctAnswer[index - 1]) {
                    result = false;
                    break;
                }
            }
        } else {
            result = false;
        }
        return result;
    }

    const showLightsSequence = () => {

        for (var i = 0; i < basket.length; i++) {
            let index = basket[i].id;
            if (basket[i].imageurl !== correctAnswer[index - 1]) {
                if (correctAnswer.includes(basket[i].imageurl)) {
                    setLightByID(index, 'yellowLight');
                } else {
                    setLightByID(index, 'redLight');
                }
            } else {
                setLightByID(index, 'greenLight');
            }
        }
    }
    const setLightByID = (boxID, lightColor) => {

        if (boxID == 1) {
            setLight1(lightColor);
        } else if (boxID == 2) {
            setLight2(lightColor);
        } else if (boxID == 3) {
            setLight3(lightColor);
        } else if (boxID == 4) {
            setLight4(lightColor);
        } else if (boxID == 5) {
            setLight5(lightColor);
        }
    }
    const fryItems = () => {

        if (isCorrectAnswer()) {
            if (btnRef.current) {
                btnRef.current.setAttribute("disabled", "disabled");
            }
            if (resetBtnRef.current) {
                resetBtnRef.current.setAttribute("disabled", "disabled");
            }
            setLight1('greenLight');
            setLight2('greenLight');
            setLight3('greenLight');
            setLight4('greenLight');
            setLight5('greenLight');
            function greet() {
                playVideo.current(congratulateVideoURL);
                setCurrentVideoURL(congratulateVideoURL);
            }
            setTimeout(greet, 500);

        } else {
            showLightsSequence();

            function wrong() {

                if (promptIndex === null) {
                    setPromptIndex(0);
                    playVideo.current(promptVideos[0]);
                } else if (promptIndex === 0) {
                    setPromptIndex(1);
                    playVideo.current(promptVideos[1]);
                } else if (promptIndex === 1) {
                    setPromptIndex(2);
                    playVideo.current(promptVideos[2]);
                } else if (promptIndex === 2) {
                    setPromptIndex(0);
                    playVideo.current(promptVideos[0]);
                } else {
                    setPromptIndex(0);
                    playVideo.current(promptVideos[0]);
                }
            }
            setTimeout(wrong, 500);
        }

    }

    const playWaitingVideo = () => {

        setCurrentVideoURL(waitingVideoURL);
        playVideo.current(waitingVideoURL);

    }

    const updateAudioStatue = (value) => {

    }

    const setUpWarningSound = () => {
        if (playAudio.current) {
            playAudio.current('./musics/30SecondTimer.mp3');
        }
    }

    return (

        <div className="foodBuildingGame">
            <div className='foodBuildingContainer'>
                <div className='headerRow'>
                    <div className='pgTitle'>
                        <div className="gameTitleContainer">
                            <div className='pgName'>Food Building</div>
                            <div className='pgDesc'>Deep Fried Codebreaker</div>
                        </div>
                        <SlideDownInDiv>
                            <div className='hintContainer'>
                                <p>Drag a food icon into each fryer and FRY to see your results!</p>
                            </div>
                        </SlideDownInDiv>
                    </div>
                </div>
                <div className='gameContent'>
                    <DragThingsToBoxesDemo
                        lightColor1={light1}
                        lightColor2={light2}
                        lightColor3={light3}
                        lightColor4={light4}
                        lightColor5={light5}
                        key={seed} updateBox={updateBox}></DragThingsToBoxesDemo>
                </div>
            </div>
            <div className='videoContainer'>
                <Timer seconds={props.seconds} gotoFailed={gotoFailed} isReversed={props.isReversed} setUpWarningSound={setUpWarningSound} timerRef={timerRef} updateTimerValue={props.updateTimerValue} />

                <Video VideoURL="./videos/4_2_Minigame_intro.mp4" actorName={actorName} actorTitle={actorTitle} poster={posterURL} updateVideoStatue={updateVideoStatue} playVideo={playVideo} />
                <div className='helpContainer'>
                    <div className='helpButton' onClick={openModal}></div>
                    <Modal
                        isOpen={modalIsOpen}
                        style={customStyles}
                        contentLabel="Food puzzle help"
                    >

                        <div className="helpPopup" onClick={closeModal}>
                            <div className='helpMessageContainer'>
                                <div className='helpLabel' />
                                <div className='whitePaperContainer' />
                                <div className='helpIcon' />
                                <div className='messageContainter'>
                                    <div className='helpMessage'>
                                        <div className='helpTitle'>Find the right sequence of deep fried foods! </div>
                                        <div className='helpDesc lightsContainer' >
                                            <div className='greenLight'>A green light above a fryer means that food is in the right spot.</div>
                                            <div className='yellowLight'>A yellow light means the food is right but it’s in the wrong spot.</div>
                                            <div className='redLight'>A red light means that food shouldn’t be fried at all!</div>
                                        </div>
                                    </div>
                                    <div className='helpButtonsContainer'>
                                        <button className='revealButton' onClick={showClear} >Click to reveal the clue!</button>
                                        <div className={`blurredClue ${isBlur}`}>
                                            <div>Start with pickle in the left fryer and cookie in the second fryer with ice cream in the middle one. Try to solve the last two combinations!</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        isOpen={gameOverModalIsOpen}
                        style={customStyles}
                        contentLabel="Game over"
                    >

                        <div className="timeOutPopup">
                            <div className='timeoutContainer'>
                                <div className='timeoutLabel' />
                                <div className='paperContainer' />
                                <div className='timeoutPictures'>
                                    <div className='pic1'></div>
                                    <div className='pic2'></div>
                                    <div className='pic3'></div>
                                </div>
                                <div className='timeoutMessage'>
                                    Oops you've run out of time!
                                </div>
                                <div className='timoutButtonsContainer'>
                                    <button className='timeoutButton' onClick={closeGameOverModal} >Continue?</button>
                                    <button className='timeoutButton' onClick={restartGame}>Restart</button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
                <div>
                    <form onSubmit={handleSubmit}>
                        <input className="submitButton" ref={btnRef} type="submit" value="Fry" />
                        <input className="submitButton" onClick={resetGame} type="reset" ref={resetBtnRef} value="Restart" />
                    </form>
                </div>
            </div>
            <Audio AudioURL="./musics/the-crackdown.mp3" autoPlay loop updateAudioStatue={updateAudioStatue} playAudio={playAudio} />
        </div>
    );

};

export default memo(FoodBuildingGame);